import { createSlice, PayloadAction } from '@reduxjs/toolkit'

// Ajuste na inicialização do estado
const getInitialState = () => {
  try {
    const savedFilial = localStorage.getItem('filialLogada');
    // Verifica se existe e se é um JSON válido
    if (savedFilial) {
      JSON.parse(savedFilial); // Teste de parse para garantir formato válido
      return savedFilial;
    }
  } catch (error) {
    console.error('Erro ao carregar filial do localStorage:', error);
    // Reseta para um valor padrão se houver erro
    localStorage.removeItem('filialLogada');
  }
  return JSON.stringify({ id: 1 }); // Valor padrão
};

const initialState = getInitialState();

const filialSlice = createSlice({
  name: 'filialLogada',
  initialState,
  reducers: {
    setFilialLogada: (state, action: PayloadAction<string>) => {
      try {
        // Tenta validar se é um JSON válido antes de salvar
        JSON.parse(action.payload);
        localStorage.setItem('filialLogada', action.payload);
        return action.payload;
      } catch (error) {
        console.error('Erro ao salvar filial:', error);
        return state; // Mantém o estado atual se houver erro
      }
    },
    setNomeFilial: (state, action: PayloadAction<string>) => {
      localStorage.setItem('nomeFilial', action.payload);
      return state; // Para este reducer, não alteramos o state de filialLogada
    }
  }
})

export const { setFilialLogada } = filialSlice.actions;
export default filialSlice.reducer